module.exports = __webpack_public_path__ + "static/MainLogo-961814aeeb5e63d3b9ab81573176e8fc.png";